'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'files';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e178';
var svgPathData = 'M144 400l288 0 0-288-88 0-8 0 0-8 0-88L144 16l0 384zM344 0l96 96 8 8 0 296 0 16-16 0-288 0-16 0 0-16 0-384 0-16 16 0L344 0zm8 96l65.4 0L352 30.6 352 96zM16 96l80 0 0 16-80 0 0 384 288 0 0-48 16 0 0 48 0 16-16 0L16 512 0 512l0-16L0 112 0 96l16 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFiles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;